import { Stack, Typography } from "@mui/material";
import type React from "react";
import { ConfirmationDialog } from "../../../widgets/confirmation-dialog/confirmation-dialog";

export const ProductQuantityCsvUploadDialog = ({
  isOpen,
  onCancel,
  onProceed,
  canProceed,
  body,
}: {
  isOpen: boolean;
  onCancel: () => void;
  onProceed: () => void;
  canProceed: boolean;
  body: React.ReactNode;
}) => {
  const confirmationDialogActions = canProceed
    ? {
        acceptAction: { title: "Proceed", onClick: onProceed },
        cancelAction: { title: "Close", onClick: onCancel },
      }
    : {
        acceptAction: { title: "Close", onClick: onCancel },
      };

  return (
    <ConfirmationDialog
      open={isOpen}
      maxWidth="md"
      fullWidth
      title="Upload Results"
      {...confirmationDialogActions}
    >
      <Stack spacing={2} minHeight={400}>
        <Typography variant="h4">Product Upload Results</Typography>
        {body}
      </Stack>
    </ConfirmationDialog>
  );
};
